const setListOfModels = (models) => {
    return {
        type: 'SET_LIST_OF_MODELS',
        payload: models
    };
};

const setCurrentModel = (model) => {
    return {
        type: 'SET_CURRENT_MODEL',
        payload: model
    };
};

const updateCurrentModel = (model) => {
    return {
        type: 'UPDATE_CURRENT_MODEL',
        payload: model
    };
};
const setCurrentPOS = (index) => {
    return {
        type: 'SET_CURRENT_MODEL_POS',
        payload: index
    };
};
//eslint-disable-next-line
export default {
    setListOfModels,
    setCurrentModel,
    updateCurrentModel,
    setCurrentPOS
};
